/**
 * Upload API — the single place that knows the backend's upload contract.
 *
 * Endpoints:
 *   - Image: POST /api/image_upload/<category>   field "imageFile" -> { imageUrl }
 *   - Video: POST /api/video_upload[/<category>]  field "videoFile" -> { videoUrl }
 *   - File:  POST /api/file_upload/<category>      field "file"      -> { imageUrl|fileUrl|url }
 */
import { http } from "@/lib/http";
import { convertHeicIfNeeded } from "@/lib/heic";

function postMultipart(url, field, file, onProgress) {
  const data = new FormData();
  data.append(field, file);
  return http
    .post(url, data, {
      headers: { "Content-Type": "multipart/form-data" },
      onUploadProgress: (e) => {
        if (onProgress && e.total) {
          onProgress(Math.round((e.loaded / e.total) * 100));
        }
      },
    })
    .then((res) => res.data);
}

export async function uploadImage(category, file, onProgress) {
  const safeFile = await convertHeicIfNeeded(file);
  return postMultipart(
    `/api/image_upload/${category}`,
    "imageFile",
    safeFile,
    onProgress,
  ).then((d) => d.imageUrl);
}

export function uploadVideo(file, onProgress, category) {
  const url = category ? `/api/video_upload/${category}` : "/api/video_upload";
  return postMultipart(url, "videoFile", file, onProgress).then(
    (d) => d.videoUrl,
  );
}

export function uploadFile(category, file, onProgress) {
  return postMultipart(
    `/api/file_upload/${category}`,
    "file",
    file,
    onProgress,
  ).then((d) => d.fileUrl ?? d.imageUrl ?? d.url);
}
